<template>
  <div id="app">
    <head-new></head-new>
    <!-- <layout-head v-else></layout-head>  -->
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import {Common} from '@/common'
import LayoutHead from '@/components/Head'
import headNew from '@/components/head-new'
export default {
  data () {
    return {
      isPartner: 1,
      isRule: 1,
      userId: '6c7057467444384f346944576968664b582b486436513d3d'
    }
  },
  components: {
    LayoutHead,
    headNew,
  },
  mounted () {
    let info_data = Common.getCookie('QDS_LOGIN_INFO');
    let loginInfo = info_data && JSON.parse(decodeURIComponent(info_data));
    this.userId = loginInfo.userId
    this.isPartner = loginInfo.isPartner ? loginInfo.isPartner : 0;
    this.isRule = loginInfo.isRule ? loginInfo.isRule : 0;
    setTimeout(() => {
      this.getRules();
    }, 300)
  },
  methods: {
    // 获取权限
    async getRules() {
      // 固参
      const tab ="all"
      const identityIde = this.userId
      const sort = "asc"
      const h5Query = 0
      const appKey = "quandashi9838616927"
      const timestamp = new Date().getTime()
      const format = "json"
      const signMethod = "md5"
      const executor = this.userId
      const v = "1.0"
      const sign = new Date().getTime()

      let source = 1;
      let urlSource = this.$route.query.source;
      let sessionSource = sessionStorage.getItem('source');
      if (urlSource != null && urlSource != undefined && urlSource != '') {
        source = urlSource
      } else if (sessionSource != null && sessionSource != undefined && sessionSource != '') {
        source = sessionSource
      } else  {
        source = 1
      }
      sessionStorage.setItem('source', source);

      let data = {
        userId: this.userId,
        tab,
        identityIde,
        sort,
        h5Query,
        appKey,
        timestamp,
        format,
        signMethod,
        executor,
        v,
        sign,
        platform: source
      }
      const url = `${this.api.soQuandashi.getUserPermList}`
      const res = await this.$http.post(url, data)
      if (res.status === 200 && res.data && res.data.code == 9091 && res.data.subCode == 10002) {
        this.loading = false
        setTimeout(() => {
          sessionStorage.setItem('userRules', JSON.stringify(res.data.data))
        }, 0)
      }
    },
  }
}
</script>

<style lang="stylus">
*
  margin 0
body, html
  background #F7F7F8
#app
  text-align center
  color #2c3e50
</style>



// WEBPACK FOOTER //
// src/App.vue